import React, { CSSProperties, ReactNode } from 'react';
import cx from 'classnames';

import s from './BFlex.module.scss';

type FlexJustify = 'normal' | 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
type FlexAlign = 'normal' | 'start' | 'center' | 'end' | 'baseline';
type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';

export interface BFlexProps {
  className?: string;
  children: ReactNode;
  justify?: FlexJustify;
  align?: FlexAlign;
  direction?: FlexDirection;
  gap?: number | string;
  fullWidth?: boolean;
  wrap?: boolean;
}

export const BFlex = (props: BFlexProps) => {
  const {
    className,
    children,
    gap,
    wrap,
    fullWidth = false,
    justify = 'normal',
    direction = 'row',
    align = 'baseline',
  } = props;

  const style: CSSProperties = {
    gap,
  };

  const mods = {
    [s.fullWidth]: fullWidth,
    [s.flexWrap]: wrap,
  };

  const additional = [
    s[`justify-${justify}`],
    s[`align-${align}`],
    s[`direction-${direction}`],
  ];

  return (
    <div className={cx(s.bFlex, mods, additional, className)} style={style}>
      {children}
    </div>
  );
};
